<template>
  <div class="sac-radio-container">
    <div class="sac-radio-row">
      <input
        :id="`${name}-${value}`"
        type="radio"
        class="sac-radio"
        :name="name"
        :checked="checked"
        :disabled="disable"
        @change="change(field, value)"
      />
      <label :for="`${name}-${value}`" class="sac-radio-label">
        {{ label }}
      </label>
    </div>
    <div v-if="subLabel" class="sac-radio-row">
      <div class="sac-radio-sub-label">
        {{ subLabel }}
      </div>
    </div>
    <div class="sac-radio-row">
      <div v-if="error" class="sac-radio-error">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SACRadio',
  props: {
    field: String,
    value: [String, Boolean],
    checked: Boolean,
    change: Function,
    label: String,
    subLabel: String,
    name: String,
    disable: Boolean,
    error: String,
  },
};
</script>

<style lang="scss" scoped>
.sac-radio-container {
  display: grid;
  justify-content: flex-start;
  align-items: center;
  .sac-radio-row {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: 20px 1fr;
    align-items: center;
  }
  .sac-radio {
    transform: scale(1.5);
  }
  .sac-radio-label-container {
    cursor: pointer;
  }
  .sac-radio-label {
    margin-left: 8px;
    font-size: 0.875rem;
    font-weight: 500;
  }
  .sac-radio-sub-label {
    grid-column: 2;
    margin-left: 8px;
    color: $N60;
    font-size: 0.875rem;
  }
  .sac-radio-error {
    grid-column: 2;
    margin-left: 8px;
    color: $TOMATO100 !important;
    font-size: 0.875rem;
    font-weight: 500;
  }
}
</style>
